import React from 'react'
import ButtonGroup from '@components/button-group'
import Image from "@components/image"
import { Link } from 'gatsby'
import { getUriFromDocument } from '@utils/routing'

const CollectionListMobile = ({ data }) => {
  const { heading, collections, ctaList, defaultImage } = data

  return (
    <div className={'flex flex-col w-full md:hidden gap-y-5'} >
      <h2>{heading}</h2>
      <div className='grid grid-cols-2 gap-y-5 gap-x-2.5 w-full'>
        {collections?.map((collection, index) => (
          <Link key={index} to={getUriFromDocument(collection)} className='flex flex-col w-full h-full gap-y-2.5 cursor-pointer justify-between'>
            <div className='aspect-1 h-full'>
              <Image image={collection?.collectionImage || collection?.mainImage || defaultImage} width={350} height={350} className={'rounded-xl'} />
            </div>
            <p className='subheadline font-normal'>{collection?.title}</p>
          </Link>
        ))}
      </div>
      <ButtonGroup isFullWidth={false} list={ctaList} />
    </div>
  )
}

export default CollectionListMobile